import { FlagIcon, BookmarkIcon, BeakerIcon } from '@heroicons/react/24/outline';

export default function Alert({ alert }) {
  let bgColor;
  let color;
  switch (alert?.type) {
    case 'info':
      bgColor = "bg-green-50";
      color = "text-black-700";
      break;
    case 'error':
      bgColor = "bg-red-50";
      color = "text-black-700";
      break;
    case 'testMode':
      bgColor = "bg-red-50";
      color = "text-red-700";
      break;
    default:
      bgColor = "bg-gray-100";
      color = "text-black-700";
  }
  const Icon = alert?.type === "info" ? BookmarkIcon : alert?.type === "testMode" ? BeakerIcon : FlagIcon;
  return (
    <div className={`text-sm px-4 py-3 ${bgColor} ${color}`} role="alert">
      <div className="flex w-full items-center">
        <Icon className={`h-6 w-6 mr-2 ${color}`} />
        <span dangerouslySetInnerHTML={{ __html: alert?.message || '' }} />
      </div>
      {alert?.bullets?.length && (
        <ul className="w-full pl-8 py-3 list-disc list-inside">
          {alert?.bullets?.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
      )}
    </div>
  );
}